import { TextField } from "@mui/material";
import { useState } from "react";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import localize from "../../../common/localize";
import ModalBackground from "../../../components/common/ModalBackground";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../../common/utils";

export default function AddObservation({
  show,
  setShow,
  dailyRoute,
  setDailyRoute,
  dailyRouteEvent,
  routeEventsToUpdate,
  setRouteEventsToUpdate,
}) {
  const [observation, setObservation] = useState(
    dailyRouteEvent?.Observation ?? ""
  );
  const [routeEvent, setRouteEvent] = useState(dailyRouteEvent);
  const [descriptionCount, setDescriptionCount] = useState(
    observation?.length ?? 0
  );
  const maximumCharactersForDescription = MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;

  const handleChange = (e) => {
    if (e.target.name === "Observation") {
      setDescriptionCount(e.target.value.length);
    }

    setObservation(e.target.value);
    setRouteEvent({
      ...routeEvent,
      Observation: e.target.value,
      ModificationDate: new Date(),
    });
  };

  const addRouteEventToEditables = (routeEvent) => {
    const index = routeEventsToUpdate
      ? routeEventsToUpdate.findIndex((element) => element.Id === routeEvent.Id)
      : -1;

    if (index >= 0) {
      routeEventsToUpdate[index] = routeEvent;
      setRouteEventsToUpdate([...routeEventsToUpdate]);
      return;
    }

    setRouteEventsToUpdate([...routeEventsToUpdate, routeEvent]);
  };

  const setObservationToDailyRouteEvent = () => {
    const index = dailyRoute.RouteEvents.findIndex(
      (element) => element.EventInfo?.Id === routeEvent.EventInfo?.Id
    );
    if (index >= 0) {
      const dailyRouteEvents = dailyRoute.RouteEvents;

      dailyRouteEvents[index] = routeEvent;
      setDailyRoute({ ...dailyRoute, RouteEvents: [...dailyRouteEvents] });

      if (routeEvent.Id > 0) {
        addRouteEventToEditables(routeEvent);
      }

      setShow(false);
    }
  };

  return (
    <ModalBackground
      showModal={show}
      setShowModal={setShow}
      title={`${localize.observations} - ${localize.code}: ${dailyRouteEvent?.EventInfo?.Code}`}
      validators={descriptionCount === 0}
      onClickToCancel={() => {
        setShow(false);
      }}
      onClickToSubmit={() => {
        setObservationToDailyRouteEvent();
        setShow(false);
      }}
      Component={
        <div style={{ width: "500px" }} className="my-2">
          <TextField
            InputLabelProps={getInputLabelProps()}
            inputProps={{
              ...getInputProps(),
              maxLength: maximumCharactersForDescription,
            }}
            size="small"
            fullWidth
            multiline
            rows={4}
            id="outlined-basic"
            name="Observation"
            label={localize.description}
            variant="outlined"
            onChange={handleChange}
            value={observation}
            helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
          />
        </div>
      }
    />
  );
}
